(function () {
  function updateFooterBarHeightVar() {
    const bar = document.querySelector('.sticky-footer-bar');
    const height = bar && window.matchMedia('(max-width: 989px)').matches ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--sticky-footer-bar-height', `${height}px`);
  }

  updateFooterBarHeightVar();
  window.addEventListener('resize', updateFooterBarHeightVar);

  function updateCartCount(itemCount) {
    const badge = document.querySelector('[data-sticky-footer-bar-cart-count]');
    if (!badge) return;
    badge.textContent = itemCount;
    badge.classList.toggle('hidden', itemCount === 0);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData && typeof event.cartData.item_count === 'number') {
        updateCartCount(event.cartData.item_count);
      }
    });
  }

  // Best-effort: if a chat app (e.g. Shopify Inbox) has already injected its own
  // bubble, prefer opening that instead of navigating to the fallback URL.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-sticky-footer-bar-chat]');
    if (!trigger) return;

    const chatBubble =
      document.querySelector('#shopify-chat button') ||
      document.querySelector('shopify-chat button') ||
      document.querySelector('[id*="chat-button" i]');

    if (chatBubble) {
      event.preventDefault();
      chatBubble.click();
    }
  });
})();
